import React from "react";
import { Card } from "semantic-ui-react";
import { Link } from "react-router-dom";
import UserAvatar from "./UserAvatar";
import { capitalize } from "utils";

const StudentCard = ({ student, showTeacher }) => {
  return (
    <Card color={student.archived ? "grey" : "teal"}>
      <Card.Content>
        <Link to={`/students/${student.id}`}>
          <UserAvatar
            name={student.name}
            useSvg
            width={32}
            height={32}
            style={{ float: "right" }}
          />
        </Link>
        <Card.Header>
          <Link to={`/students/${student.id}`}>{student.name}</Link>
        </Card.Header>

        {showTeacher ? <Card.Meta>{student.myTeacher.name}</Card.Meta> : null}
        <Card.Meta>
          {`${capitalize(student.reportFrequency)} Reports`}
        </Card.Meta>
        <Card.Meta>{student.archived ? "Archived" : false}</Card.Meta>
      </Card.Content>
    </Card>
  );
};
export default StudentCard;
